import { render, staticRenderFns } from "./NotaArrematacao.vue?vue&type=template&id=f4cb9096"
import script from "./NotaArrematacao.vue?vue&type=script&lang=js"
export * from "./NotaArrematacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports